enum DefinedDrawers {
	HistoryTodo = 'historyTodo',
	Settings = 'settings',
	HowToUse = 'howToUse',
}

export default DefinedDrawers;
